export const UPDATE_WHATSAPP_NOTIFICATION_CHARGES_REQUEST = "UPDATE_WHATSAPP_NOTIFICATION_CHARGES_REQUEST";
export const UPDATE_WHATSAPP_NOTIFICATION_CHARGES_SUCCESS = "UPDATE_WHATSAPP_NOTIFICATION_CHARGES_SUCCESS";
export const UPDATE_WHATSAPP_NOTIFICATION_CHARGES_FAILURE = "UPDATE_WHATSAPP_NOTIFICATION_CHARGES_FAILURE";
export const UPDATE_WHATSAPP_NOTIFICATION_CHARGES_RESET = "UPDATE_WHATSAPP_NOTIFICATION_CHARGES_RESET";
export const updateWhatsappNotificationChargesRequest = (payload) => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_CHARGES_REQUEST,
    payload,
});
export const updateWhatsappNotificationChargesSuccess = (payload) => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_CHARGES_SUCCESS,
    payload,
});
export const updateWhatsappNotificationChargesFailure = (payload) => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_CHARGES_FAILURE,
    payload,
});
export const updateWhatsappNotificationChargesReset = () => ({
    type: UPDATE_WHATSAPP_NOTIFICATION_CHARGES_RESET,
});
